import { useMemo } from "react";
import { Box } from "@mui/material";
import useFetchStatusAPI from "../../hooks/useFetchStatusAPI";
import BarGraph from "../BarGraph/BarGraph";
import useWindowSize from "../../assets/customHooks/useWindowSize";
import AppLoader from "../AppLoader/AppLoader";
import "./HistoricalDataGraph.scss";
import { useTranslation } from "react-i18next";

const HistoricalDataGraph = ({ statusType, services }) => {
	console.log(statusType)
	const api = statusType === "Gold" ? "REACT_APP_STATUS_API_GOLD"
	: statusType === 'BAT' 
	? "REACT_APP_STATUS_API_BAT"
	 : "REACT_APP_STATUS_API_PROD";
	 console.log(api,'asd')
	const urlType = api + "_DAILY_URL";
	const { i18n } = useTranslation();

	const options = {
		headers: { "x-api-key": process.env[api] },
	};

	const url = process.env[urlType];

	const { width } = useWindowSize();
	const { data, loading } = useFetchStatusAPI(url, options, statusType, services);

	const isMobile = useMemo(() => width! < 1100, [width]);
	const toLocal = (date) =>
		date.toLocaleString(i18n.language, {
			day: "numeric",
			month: "long",
			year: "numeric",
		});

	const content = useMemo(() => {
		if (!data) return null;

		return data.map((status) => {
			const label = status["API"] === "OrderReshopShop" ? "OrderReshop" : status["API"];

			if (
				(label as string) === "OrderReshopPrice" ||
				(label as string).includes("AIR") ||
				(label as string) === "null"
			)
				return <></>;
			const count = Object.keys(status["data"][0]).length;
			const chunkSize = width! < 1100 ? 30 : Object.keys(status["data"][0]).length;
			const initialIndex = count - chunkSize >= 0 ? count - chunkSize : 0;
			const startIndex = initialIndex + chunkSize;

			const displayedData = Object.entries(status["data"][0]).slice(startIndex - chunkSize, startIndex);
			const startDate = toLocal(new Date(displayedData[0]?.[0] ?? ""));
			const endDate = toLocal(new Date(displayedData[displayedData.length - 1]?.[0] ?? ""));

			return (
				<div key={label}>
					<Box
						className="sub-container"
						tabIndex={-1}
						aria-label={`${label} 90 days up time percentage: ${status["UPTime"]}`}
						sx={{
							width: isMobile ? "376px" : "100%",
						}}
					>
						<div className="header-container">
							<div className="header-service">
								<img
									src={services[label === "OrderReshop" ? "OrderReshopShop" : label]}
									alt={label}
									className="service-icon"
									aria-hidden="true"
								/>
								<span className="service-label">{label.toString() === "OrderRetrieve" ? "OrderView" : label}</span>
							</div>
							{!isMobile && startDate && endDate &&
								<div className="dateAndPercentBar" >
									<div>{startDate + " - " + endDate}</div>
									<div className="percentText">{status["UPTime"]}</div>
								</div>}
							{/* <span className="percentage">{status["UPTime"]}</span> */}
							<span className="percentage"></span>
						</div>
						<BarGraph
							service={label}
							data={status["data"][0]}
							renderTooltipContent={(data) => <HistoricalDataTooltip data={data} locale={i18n.language} />}
							type={"daily"}
						/>
					</Box>
				</div>
			);
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data, isMobile, i18n.language]);

	return (
		<>
			{loading ? (
				<AppLoader />
			) : (
				<div
					className="historical-container"
					role="group"
					aria-label="Historical data graph group"
				>
					{content ? content.map((item, index) => (
						<div key={index}>{item}</div>
					)) : null}
				</div>
			)}
		</>
	);
};

const HistoricalDataTooltip = ({ data, locale }) => {
	const date = new Date(Date.parse(data.date));
	return (
		<>
			<div className="tooltip-date">{date.toLocaleString(locale, { day: "numeric", month: "long", year: "numeric" })}</div>
			<hr aria-hidden="true" />
			<div className="tooltip-text">{data.statusTitle}</div>
		</>
	);
};
export default HistoricalDataGraph;
